export default "__VITE_ASSET__6oAlkWgI__"